import angular from 'angular';
import ngRoute from 'angular-route';
import ngAnimate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
//import ngIdle from 'ng-idle';
import hmTouchEvents from 'angular-hammer';
//import dropdown from 'angular-ui-bootstrap/src/dropdown';
import uiBootstrap from 'angular-ui-bootstrap';

//import Snap from 'snapsvg-cjs';
import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
//import FBXLoader from 'three-fbx-loader';

import '../style/bootstrap-qms.css';
import '../style/app.css';

import './js/qms.services.js';
import './js/qms.controllers.js';
import './js/qms.directives.js';

import './js/threeServices.js';
import './js/threeControllers.js';
import './js/threeDirectives.js';

//import * as objList from '../public/data/objList.json';
//import * as settings from '../public/data/settings.json';



let app = () => {
  return {
    template: require('./app.html'),
    controller: 'AppCtrl',
    controllerAs: 'app'
  }
};

let test = () => {
  return {
    template: '<h1>HELLO FROM TEST</h1>',
    controller: function($element,$scope) {
      var s = Snap($element[0]);
      var c = s.circle(200,100,100);
      var d = c.clone();
      d.attr({transform:'t200,50',fill:'#c00',opacity:0.1});
      setTimeout(function() {
          d.animate({transform:'t0,-50',opacity:1},3000,mina.easeinout());
      },5000)
    }
  }
}

class AppCtrl {
  constructor() {
    this.url = 'https://qmscotland.co.uk';
  }
}
AppCtrl.$inject = ["$scope", "$http", "$filter"];


const MODULE_NAME = 'qms';

angular.module(MODULE_NAME, ['ngRoute','ngAnimate','ngSanitize','hmTouchEvents','ui.bootstrap','qms.controllers','qms.services','qms.directives','threeViewer.services','threeViewer.directives','threeViewer.controllers'])
  .config(['$routeProvider',function($routeProvider) {

      $routeProvider.when('/', {
            templateUrl : 'views/home.html',
          })
          .when('/grid-introduction', {
            templateUrl : 'views/grid-introduction.html',
          })
          .when('/handling-points', {
            templateUrl : 'views/handling-points.html',
            controller : 'handlingCtrl'
          })
          .when('/virtual-beast', {
            templateUrl : 'views/virtual-beast.html',
          })
          .when('/assessment-points', {
            templateUrl : 'views/assessment-points.html',
          })
          .when('/weight-issues', {
            templateUrl : 'views/weight-issues.html',
          })
          .when('/dirty-livestock', {
            templateUrl : 'views/dirty-livestock.html',
          })
          .when('/dressing-specifications', {
            templateUrl : 'views/dressing-specifications.html',
          })
          .when('/condemnations', {
            templateUrl : 'views/condemnations.html',
          })
          .when('/test', {
            templateUrl : 'views/bump-test.html',
          })
          .when('/test2', {
            templateUrl : 'views/fbx-test.html',
          })
          .otherwise({
            templateUrl : 'views/home.html',
          })


  }])
  .run(['$rootScope','$location','$routeParams', function($rootScope, $location, $routeParams) {

  		$rootScope.sitePath = window.location.host + window.location.pathname;

  		$rootScope.dialog = null;
  		$rootScope.curIdx = 0;
  		$rootScope.navActive = $location.path();
      $rootScope.navPrev = $location.path();
      $rootScope.THREE = THREE;
      $rootScope.THREE.Cache.enabled = true;
      $rootScope.OBJLoader = OBJLoader;
      $rootScope.FBXLoader = FBXLoader;
      $rootScope.OrbitControls = OrbitControls;

  		$rootScope.load3D = {
  			status: 'waiting',
  			items: null
  		}

  		$rootScope.$on('$routeChangeSuccess', function(e, current, pre) {
  		  console.log('Current route name: ' + $location.path());
        //console.log(pre);
  		  $rootScope.navActive = $location.path();
        if(typeof pre !== 'undefined') {
          $rootScope.prevStage = (typeof pre.params.stage !== 'undefined') ? pre.params.stage : null;
        }
  		});

      //Idle.watch()-;

  }])
  .directive('app', app)
  .directive('test', test)
  .controller('AppCtrl', AppCtrl);


export default MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app/app.js